module.exports = __webpack_public_path__ + "navbar.afd2b3f26de396af8652f4116f805067.png";